import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import './TestResultsPage.css';
import Matrix from '../ResultComp/Matrix';
import GroupParam from '../ResultComp/GroupParam';
import Status from '../ResultComp/Status';
import Stars from '../ResultComp/Stars';
import Lider from '../ResultComp/Lider';
import IndexConf from '../ResultComp/IndexConf';
import LiderResult from '../ResultComp/LiderResult';
import BelbenResult from '../ResultComp/BelbenResult';

const TestResultsPage = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const { testId } = useParams();
    const [testData, setTestData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('');
    
    // Состояния для каждого типа результатов
    const [sociometryResults, setSociometryResults] = useState(null);
    const [leadershipResults, setLeadershipResults] = useState(null);
    const [belbenResults, setBelbenResults] = useState(null);
    const [resultsLoading, setResultsLoading] = useState({
        sociometry: false,
        leadership: false,
        belben: false
    });
    const [resultsError, setResultsError] = useState({
        sociometry: null,
        leadership: null,
        belben: null
    });

    // Функция для получения типа вопроса (универсальная)
    const getQuestionType = (question) => {
        return question.quest_type || question.question_type || 'unknown';
    };

    // Функция для получения имени вкладки
    const getTabName = (type) => {
        switch(type) {
            case 'sociometry': return 'Социометрия';
            case 'leadership': return 'Лидерство';
            case 'belben': return 'Роли в команде';
            default: return type;
        }
    };

    // Загрузка данных теста
    useEffect(() => {
        const fetchTestData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(`http://185.250.149.189:8000/api/v1/Test?id=${testId}`, {
                    headers: { 'Authorization': `Token ${token}` }
                });

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
                
                const data = await response.json();
                
                if (!data.tests || data.tests.length === 0) {
                    throw new Error('Тест не найден');
                }
                
                const test = data.tests[0];
                setTestData(test);
                
                // Получаем уникальные типы вопросов
                const types = new Set(test.questions.map(q => getQuestionType(q)));
                if (types.size > 0) {
                    const typesArray = Array.from(types);
                    setActiveTab(typesArray[0]);
                }
                
            } catch (error) {
                console.error('Ошибка загрузки данных теста:', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTestData();
    }, [testId]);

    // Загрузка результатов по активной вкладке
// Загрузка результатов по активной вкладке
// Загрузка результатов по активной вкладке
// Загрузка результатов по активной вкладке
useEffect(() => {
    if (!activeTab || !testData) return;
    
    const fetchResults = async () => {
        try {
            console.log(`[${activeTab}] Начало загрузки результатов...`);
            
            // Проверка кэша
            if (
                (activeTab === 'sociometry' && sociometryResults) ||
                (activeTab === 'leadership' && leadershipResults) ||
                (activeTab === 'belben' && belbenResults)
            ) {
                console.log(`[${activeTab}] Результаты уже загружены, пропускаем запрос`);
                return;
            }

            setResultsLoading(prev => ({ ...prev, [activeTab]: true }));
            setResultsError(prev => ({ ...prev, [activeTab]: null }));
            
            const token = localStorage.getItem('authToken');
            if (!token) throw new Error('Токен авторизации не найден');
            
            let url;
            switch (activeTab) {
                case 'sociometry':
                    url = `http://185.250.149.189:8000/api/v1/Results/Sociometric/Matrix?test_id=${testId}`;
                    break;
                case 'leadership':
                    url = `http://185.250.149.189:8000/api/v1/Results/Leadership?test_id=${testId}`;
                    break;
                case 'belben':
                    url = `http://185.250.149.189:8000/api/v1/Results/Belben?test_id=${testId}`;
                    break;
                default:
                    return;
            }
            
            console.log(`[${activeTab}] Запрос на URL: ${url}`);
            const response = await fetch(url, {
                headers: { 'Authorization': `Token ${token}` }
            });
            
            // Мониторинг: ответ сервера
            console.log(`[${activeTab}] Ответ сервера:`, {
                status: response.status,
                ok: response.ok
            });
            
            // Обработка HTTP ошибок
            if (!response.ok) {
                let errorText = '';
                try {
                    errorText = await response.text();
                    console.error(`[${activeTab}] Текст ошибки: ${errorText}`);
                } catch (textError) {
                    console.error(`[${activeTab}] Ошибка чтения текста ответа:`, textError);
                }
                
                if (response.status === 500) {
                    throw new Error('Результаты еще не готовы (500)');
                }
                throw new Error(`Ошибка HTTP: ${response.status}`);
            }
            
            const data = await response.json();
            console.log(`[${activeTab}] Полученные данные:`, data);
            
            // Обработка данных с учетом новой структуры
            switch (activeTab) {
                case 'sociometry':
                    // Анализ структуры ответа
                    console.log('[sociometry] Структура ответа:', {
                        hasResults: !!data.results,
                        hasMatrix: !!data.results?.matrix,
                        keys: Object.keys(data)
                    });
                    
                    // Проверка существования matrix в новой структуре
                    const matrixData = data.results?.matrix || data.matrix;
                    
                    if (!matrixData) {
                        console.error('[sociometry] Ошибка: matrix отсутствует в ответе');
                        throw new Error('Результаты социометрии еще не готовы');
                    }
                    
                    // Сохраняем данные в едином формате
                    const normalizedData = {
                        test_id: data.test_id,
                        matrix: matrixData
                    };
                    
                    console.log('[sociometry] Нормализованные данные:', normalizedData);
                    setSociometryResults(normalizedData);
                    break;
                    
                case 'leadership':
                    if (!data.results || data.results.length === 0) {
                        throw new Error('Результаты лидерства еще не готовы');
                    }
                    setLeadershipResults(data);
                    break;
                    
                case 'belben':
                    if (!data.results || data.results.length === 0) {
                        throw new Error('Результаты ролей в команде еще не готовы');
                    }
                    setBelbenResults(data);
                    break;
                    
                default:
                    break;
            }
            
            console.log(`[${activeTab}] Данные успешно обработаны и сохранены`);
            
        } catch (error) {
            console.error(`[${activeTab}] Ошибка загрузки результатов:`, error);
            
            // Формируем понятное сообщение для пользователя
            let errorMessage = error.message;
            if (errorMessage.includes('500') || errorMessage.includes('еще не готовы')) {
                errorMessage = `Результаты ${getTabName(activeTab)} еще не готовы`;
            }
            
            setResultsError(prev => ({ ...prev, [activeTab]: errorMessage }));
        } finally {
            setResultsLoading(prev => ({ ...prev, [activeTab]: false }));
            console.log(`[${activeTab}] Завершение загрузки`);
        }
    };
    
    fetchResults();
}, [activeTab, testId, testData, sociometryResults, leadershipResults, belbenResults]);

    // Рендер контента для вкладки
    const renderTabContent = () => {
        if (resultsLoading[activeTab]) {
            return <div className="results-placeholder">
                <p>Загрузка результатов...</p>
            </div>;
        }
        
        if (resultsError[activeTab]) {
            return (
                <div className="results-placeholder">
                    <div className="error-message">{resultsError[activeTab]}</div>
                </div>
            );
        }
        
        switch (activeTab) {
            case 'sociometry':
                return (
                    <>
                        <h1>Социоматрицы</h1>
                        <Matrix testID={parseInt(testId, 10)} />
                        <h1>Групповые показатели</h1>
                        <GroupParam testID={parseInt(testId, 10)} />
                        <Status testID={parseInt(testId, 10)} />
                        <h1>О группе звезд</h1>
                        <Stars testID={parseInt(testId, 10)} />
                        <h1>Лидеры</h1>
                        <Lider testID={parseInt(testId, 10)} />
                        <IndexConf testID={parseInt(testId, 10)} />
                    </>
                );
                
            case 'leadership':
                return leadershipResults ? (
                    <LiderResult testID={parseInt(testId, 10)} />
                ) : (
                    <div className="results-placeholder">
                        <p>Результаты лидерства еще не готовы</p>
                    </div>
                );
                
            case 'belben':
                return belbenResults ? (
                    <BelbenResult testID={parseInt(testId, 10)} />
                ) : (
                    <div className="results-placeholder">
                        <p>Результаты ролей в команде еще не готовы</p>
                    </div>
                );
                
            default:
                return (
                    <div className="results-placeholder">
                        <h2>Результаты</h2>
                        <p>Выберите тип тестирования для просмотра результатов</p>
                    </div>
                );
        }
    };

    if (loading) {
        return (
            <div className="dashboard">
                <Sidebar isCollapsed={isSidebarCollapsed} 
                         toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
                <TopBar isCollapsed={isSidebarCollapsed} />
                <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="content-container">
                        <div style={{ display: 'flex', justifyContent: 'space-between', 
                                     alignItems: 'center', marginBottom: '30px' }}>
                            <h1>Результаты тестирования</h1>
                        </div>
                        <p>Загрузка данных теста...</p>
                    </div>
                </main>
            </div>
        );
    }

    if (error || !testData) {
        return (
            <div className="dashboard">
                <Sidebar isCollapsed={isSidebarCollapsed} 
                         toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
                <TopBar isCollapsed={isSidebarCollapsed} />
                <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="content-container">
                        <div style={{ display: 'flex', justifyContent: 'space-between', 
                                     alignItems: 'center', marginBottom: '30px' }}>
                            <h1>Результаты тестирования</h1>
                        </div>
                        <div className="error-message">
                            {error || 'Данные теста не найдены'}
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    // Получаем уникальные типы вопросов (универсальный способ)
    const questionTypes = Array.from(
        new Set(testData.questions.map(q => getQuestionType(q)))
    );

    return (
        <div className="dashboard">
            <Sidebar isCollapsed={isSidebarCollapsed} 
                     toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
            <TopBar isCollapsed={isSidebarCollapsed} />
            
            <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="content-container">
                    <div style={{ display: 'flex', justifyContent: 'space-between', 
                                 alignItems: 'center', marginBottom: '30px' }}>
                        <h1>Результаты тестирования: {testData.name}</h1>
                    </div>

                    {/* Вкладки с типами вопросов */}
                    <div className="results-tabs-container">
                        {questionTypes.map(type => (
                            <button
                                key={type}
                                className={`results-tab-button ${activeTab === type ? 'active' : ''}`}
                                onClick={() => setActiveTab(type)}
                            >
                                {getTabName(type)}
                            </button>
                        ))}
                    </div>

                    {/* Контент активной вкладки */}
                    {renderTabContent()}
                </div>
            </main>
        </div>
    );
};

export default TestResultsPage;